"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protagonist = void 0;
class Protagonist {
    constructor() {
        this.name = 'Protagonist';
        this.description = 'Have at least 5 TR more than any other player';
    }
    getScore(player) {
        const ownTr = player.getTerraformRating();
        const highestOtherTR = Math.max(...player.game.getPlayers().filter((p) => p.id !== player.id).map((player) => player.getTerraformRating()));
        return ownTr - highestOtherTR;
    }
    canClaim(player) {
        return this.getScore(player) >= 5;
    }
}
exports.Protagonist = Protagonist;
//# sourceMappingURL=Protagonist.js.map